@for (option of regionalBanks; let i = $index; track option) {
  <div (click)="selectRegionalBank(option)" class="flex flex-col mb-4 cursor-pointer">
    <div class="flex flex-row">
      <div class="flex flex-1 items-center">
        <img [src]="bank().logo" class="w-8 h-8 mr-3" />
        <div class="flex flex-col">
          <span class="text-secondary text-xs mb-1">{{ bank().name }}</span>
          <span class="text-secondary font-bold text-sm">{{ option.name }}</span>
        </div>
      </div>
      <img class="mr-2" src="../../../../../assets/images/svg/see-more-arrow.svg" />
    </div>
    @if (i < regionalBanks.length - 1) {
      <div class="mt-4 h-[1px] bg-gray-300"></div>
    }
  </div>
}
